import { FC } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'
import { DriverDocuments } from 'views/pages/LogisticsKR/CarriersKR/CarrierKRDetails/CarrierAccordion/DriversDocuments/DriverDocuments'
import { CarDocuments } from 'views/pages/LogisticsKR/CarriersKR/CarrierKRDetails/Cars/CarDocuments'
import { TrailerDocuments } from 'views/pages/LogisticsKR/CarriersKR/CarrierKRDetails/Trailers/TrailerDocuments'
import { CarrierDocsInfo } from 'views/pages/LogisticsKR/types'
import { AButton } from 'views/components/Analytics'
import { CarrierDocWrapper } from './CarrierDocWrapper'

type Props = {
  carrierDocsInfo: CarrierDocsInfo
  onClose: () => void
  onSuccess: () => void
}
export const UploadMissingDocModal: FC<Props> = ({ carrierDocsInfo, onClose, onSuccess }) => {
  const { t } = useTranslation('logisticsKR')
  let docControl: JSX.Element | null = null
  let title = ''
  if (carrierDocsInfo.car) {
    docControl = <CarDocuments carId={carrierDocsInfo.car.id} />
    title = `${t('missingDocs.uploadDocForCar')} ${carrierDocsInfo.car.licence_number}`
  } else if (carrierDocsInfo.trailer) {
    docControl = <TrailerDocuments trailerId={carrierDocsInfo.trailer.id.toString()} />
    title = `${t('missingDocs.uploadDocForTrailer')} ${carrierDocsInfo.trailer.licence_number}`
  } else if (carrierDocsInfo.driver) {
    docControl = <DriverDocuments driverId={carrierDocsInfo.driver.id} />
    title = `${t('missingDocs.uploadDocForDriver')} ${carrierDocsInfo.driver.id}`
  } else {
    docControl = <CarrierDocWrapper carrierId={carrierDocsInfo.carrier.id} />
    title = `${t('missingDocs.uploadDocForCarrier')} ${_.truncate(carrierDocsInfo.carrier.name, { length: 20 })}`
  }

  return (
    <ResponsiveModal
      id="uploadMissingDocModal"
      title={title}
      onClose={onClose}
      customFooter={
        <div style={{ marginTop: 20 }}>
          <AButton
            id="refreshDocs"
            onClick={() => {
              onSuccess()
              onClose()
            }}
          >
            {t('missingDocs.finish')}
          </AButton>
        </div>
      }
    >
      <SharedModalContent>{docControl}</SharedModalContent>
    </ResponsiveModal>
  )
}
